import NodeLockPannelService from './NodeLockPannelService.js';

export default class ExcelExportService {

  static async exportToExcel(serviceMethod, payload, config = {}) {
    try {
      // Ensure the service method exists
      if (!NodeLockPannelService[serviceMethod]) {
        throw new Error(`Service method '${serviceMethod}' not found`);
      }

      // Prepare the export payload
      const exportPayload = Object.assign({}, payload, {
        generateExcel: "1"
      });

      // Default config for blob response
      const defaultConfig = Object.assign({
        responseType: "blob"
      }, config);

      // Call the service method
      const response = await NodeLockPannelService[serviceMethod](exportPayload, defaultConfig);
      
      return response.data;
    } catch (error) {
      console.error('Excel export failed:', error);
      throw error;
    }
  }

  static async exportNotBilledContainer(payload) {
    return this.exportToExcel('getAllNotBillContainerDash', payload);
  }


  static async exportWithService(service, method, payload, config = {}) {
    try {
      if (!service || typeof service[method] !== 'function') {
        throw new Error(`Invalid service or method: ${method}`);
      }

      const exportPayload = Object.assign({}, payload, {
        generateExcel: "1"
      });

      const defaultConfig = Object.assign({
        responseType: "blob"
      }, config);

      const response = await service[method](exportPayload, defaultConfig);
      return response.data;
    } catch (error) {
      console.error('Excel export failed:', error);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/ExcelExportService.js